// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"f5a933cd","545":"f17022e5","685":"f17022e5"}[chunkId] + ".chunk.css";
};